var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-16 18:31:26
 * @modify date 2021-08-16 18:31:26
 * @desc 系统初始化登陆 用户信息信息编辑注册不要在这里写
 */
import { AuthEncryption } from '@mamba-le/auth';
import lodash from 'lodash';
import { BindAll } from 'lodash-decorators';
import { computed } from 'mobx';
import { forkJoin, lastValueFrom, Subject } from 'rxjs';
import { EnumAPI } from '../../apis';
import AppEnv from '../../env';
import { AjaxBasics } from './../../libraries';
import { onCreateFactoryAuth } from './auth';
import { UserInfoController } from './userInfo';
import { onCreateFactoryUser } from './userModel';
let SystemController = class SystemController {
    constructor() {
        /**
         * 认证模块 默认从 cookie 中获取 token 不需要手动设置 token
         * 除非是地址栏解析或者其他方式等等
         * @memberof SystemController
         */
        this.Auth = onCreateFactoryAuth();
        /**
         * 用户信息
         * @memberof SystemController
         */
        this.User = onCreateFactoryUser();
        this.UserInfo = new UserInfoController();
        /**
         * 用户异步数据加载订阅
         * @type {Promise<any>}
         * @memberof ControllerUser
         */
        this.UserSubject = new Subject();
    }
    // /**
    //  * cookie 值
    //  * @memberof SystemController
    //  */
    // readonly CookieKey = 'SALES_TOKEN';
    // readonly CookieDomain = '.lenovo.com.cn';
    // readonly CookieOneDomain = '.lenovo.com';
    // /**
    //  * token key
    //  * @memberof SystemController
    //  */
    // readonly SalesTokenKey = 'ssotoken';
    /**
     * token
     * @readonly
     * @memberof SystemController
     */
    get AccessToken() {
        return this.Auth.AccessToken;
    }
    /**
     * 登陆状态
     * @readonly
     * @memberof SystemController
     */
    get LoggedIn() {
        // if (this.User.loading) {
        //   return false;
        // }
        return !lodash.isEmpty(this.AccessToken);
    }
    /**
     * 重置 Token
     */
    resetToken(token) {
        if (token) {
            this.Auth.onSaveAccessToken(token);
        }
    }
    /**
     * 解析地址栏携带的登陆信息
     * @memberof SystemController
     */
    onParseQueryToken(query) {
        if (lodash.hasIn(query, 'token')) {
            const token = lodash.get(query, 'token');
            token && this.Auth.onSaveAccessToken(token);
        }
        else if (lodash.hasIn(query, 'share')) {
            const [token] = lodash.split(lodash.get(query, 'share'), AppEnv.shareSeparate);
            token && this.Auth.onSaveAccessToken(token);
            // 小程序传递回来的授权 URL
        }
        else if (lodash.hasIn(query, 'signedUrl')) {
            const signedUrl = lodash.get(query, 'signedUrl');
            const token = AuthEncryption.AES_Decrypt(signedUrl);
            token && this.Auth.onSaveAccessToken(token);
        }
    }
    /**
     * 校验登陆状态
     * @memberof SystemController
     */
    onVerify(infoType = false) {
        return this.onGetUserInfo();
    }
    /**
     * 获取用户信息数据
     * @returns
     */
    async onGetUserInfoResponse() {
        try {
            await this.Auth.HydrateAsync;
            if (lodash.isEmpty(this.AccessToken) ||
                this.User.eqAccessToken(this.AccessToken)) {
                this.UserSubject.complete();
                return this.User.value;
            }
            const response = await lastValueFrom(forkJoin([
                AjaxBasics.request(EnumAPI.company_auth_token),
                AjaxBasics.request(EnumAPI.partner_partnerIdentity_findInfo_new),
                AjaxBasics.request(EnumAPI.accountsvr_get_userinfo),
                AjaxBasics.request(EnumAPI.accountsvr_identity_ischoose),
                AjaxBasics.request(EnumAPI.partner_get_partnerIdentity_new),
            ]));
            console.log(response, 'response');
            const UserInfo = lodash.merge({
                AccessToken: this.AccessToken,
            }, 
            // 企业信息
            lodash.get(response, '[0]', {}), 
            // 组织信息
            lodash.get(response, '[1]', {}), 
            // 用户信息
            lodash.get(response, '[2]', {}), {
                optionIdentity: lodash.get(response, '[3]', false),
                indentityList: lodash.get(response, '[4]', []),
            });
            this.UserSubject.complete();
            return UserInfo;
        }
        catch (error) {
            this.UserSubject.complete();
            console.error(error);
            throw error;
        }
    }
    /**
     * 获取用户信息
     * @returns
     */
    async onGetUserInfo() {
        try {
            const UserInfo = await this.onGetUserInfoResponse();
            this.User.set(UserInfo);
            const cityCode = lodash.get(UserInfo, 'userExtendDTO.cityCode');
            this.getCitySales(cityCode);
            // this.User.toggleLoading(false);
            return UserInfo;
        }
        catch (error) {
            await this.onLoginOut();
            // this.User.toggleLoading(false);
        }
    }
    /**
     * 退出登录
     * @return {*}
     * @memberof SystemController
     */
    async onLoginOut() {
        await this.Auth.HydrateAsync;
        await Promise.all([this.Auth.onClear(), AppEnv.onClear()]);
        return this.User.set({});
    }
    /**
     * 检查用户是否登陆
     * @return {*}
     * @memberof SystemController
     */
    onInspectUser() {
        if (this.LoggedIn) {
            return this.User.value;
        }
        throw '未登录';
    }
    /**
     * 根据用户信息获取sales的相关信息
     * @returns
     */
    async getCitySales(cityCode) {
        if (!cityCode)
            return;
        try {
            const res = await AjaxBasics.request({
                ...EnumAPI.usersvr_salesInfo,
                body: { salesCityCode: cityCode },
            });
            this.User.merge({ salesInfo: lodash.get(res, [0]) });
        }
        catch (error) { }
    }
};
__decorate([
    computed
], SystemController.prototype, "AccessToken", null);
__decorate([
    computed
], SystemController.prototype, "LoggedIn", null);
SystemController = __decorate([
    BindAll()
], SystemController);
export { SystemController };
